import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const CSSLesson37 = () => {
   
    const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   h1 {
    border: 5px solid red;
    padding: 25px;
   }
   
   h1 {
    border: 4px dotted blue;
    padding: 25px;
   }

   div {
    border: double;
   }
  `
  );
 
  const code1 = (
  'text',
  `
   div {
    border-color: blue;
   }
  `
  );

  const code2 = (
  'text',
  `
   h1 {
    border-block: 5px solid red;
   }

   h1 {
    border-block: 4px dotted blue;
   }

   div {
    border-block: double;
   }
  `
  );

  const code3 = (
    'text',
    `
     .element {
      border-block: 5px solid red;
      writing-mode: horizontal-tb;

     }
    `
    );

  const code4 = (
    'text',
    `
     #table1 {
      border-collapse: separate;

     }
     #table1 {
      border-collapse: collapse;

     }
    `
    );

  const code5 = (
    'text',
    `
     #corners {
      border-radius: 25px;
      border: 2px solid #cc5500;
      padding: 25px;
      width: 200px;
      height: 150px

     }
     
    `
    );

    const code6 = (
        'text',
        `
         #example {
          border-radius: 2em / 5em;
    
         }
           /* is equivalent to */
         #example {
          border-top-left-radius: 2em 5em;
          border-top-right-radius: 2em 5em;
          border-bottom-right-radius: 2em 5em;
          border-bottom-left-radius: 2em 5em;
    
         }
         
         
        `
        );
 


  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>

          <div className="alert alert-secondary" role="alert">
          <h4>CSS Borders</h4>    
 <p>
        The CSS border properties allow you to specify the style, width, and color of an element's border.
    </p><br/>
    <h4><strong>
        Border Style</strong>
    </h4>
    <p>
        The border-style property specifies what kind of border to display.
    </p>
    <p>
        The following values are allowed:
    </p>
    <ol class="list-group list-group-numbered mb-4">
        <li class="list-group-item"> dotted - Defines a dotted border </li>
        <li class="list-group-item"> dashed - Defines a dashed border</li>
        <li class="list-group-item"> solid - Defines a solid border</li>
        <li class="list-group-item"> double - Defines a double border</li>
        <li class="list-group-item"> groove - Defines a 3D grooved border. The effect depends on the border-color value</li>
        <li class="list-group-item">
            ridge - Defines a 3D ridged border. The effect depends on the border-color value
        </li>
        <li class="list-group-item">
            inset - Defines a 3D inset border. The effect depends on the border-color value
        </li>
        <li class="list-group-item">
            outset - Defines a 3D outset border. The effect depends on the border-color value
        </li>
        <li class="list-group-item">
            none - Defines no border
        </li>
        <li class="list-group-item">
            hidden - Defines a hidden border
        </li>
    </ol>
    </div>


    <div className="alert alert-secondary" role="alert">
    <h4><strong></strong>
        Border Width
    </h4>
    <p>
        The <b class="text-danger">border-width</b> property specifies the width of the four borders.
    </p>
    <p>
        The width can be set as a specific size (in px, pt, cm, em, etc) or by using one of the three pre-defined values: <b class="text-danger">thin</b>, <b class="text-danger">medium</b>, or <b class="text-danger">thick</b>.
    </p>
    <p>
        The <b class="text-danger">border-width</b> property can have from one to four values (for the top border, right border, bottom border, and the left border).
    </p>
    </div>

  
    <div className="alert alert-secondary" role="alert">
    <h4><strong>
        Border Color</strong>
    </h4>
    <p>
        The <b class="text-danger">border-color</b> property is used to set the color of the four borders.
    </p>
    <p>
        The color can be set by:
    </p>

    <ol class="list-group list-group-numbered mb-4">
        <li class="list-group-item"> name - specify a color name, like "red"</li>
        <li class="list-group-item">
            Hex - specify a hex value, like "#ff0000"
        </li>
        <li class="list-group-item">
            RGB - specify a RGB value, like "rgb(255,0,0)"
        </li>
        <li class="list-group-item">transparent</li>
    </ol>
    <CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    
    <CopyBlock
    language={"css"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>


    <div className="alert alert-secondary" role="alert">
<h4><strong>Border Block</strong></h4>
<p>The CSS <b class="text-danger">border-block</b> property is very similar to CSS property border, but the <b class="text-danger">border-block</b> property is dependent on block direction.</p>
<p>The <b class="text-danger">border-block</b> property is a shorthand property for these properties:</p>
 <ol class="list-group mb-4">
        <li class="list-group-item">
           <b class="text-danger">border-block-width</b>
        </li>
        <li class="list-group-item">
             <b class="text-danger">border-block-style (required)</b>
        </li>
        <li class="list-group-item"><b class="text-danger">border-block-color</b></li>
    </ol>
    <CopyBlock
    language={"css"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>


 
    <div className="alert alert-secondary" role="alert">
    <h4><strong>Border Bottom</strong></h4>
<p>The <b class="text-danger">border-bottom</b> property is a shorthand property for (in the following order):</p>
 <ul class="list-group mb-4">
        <li class="list-group-item">
           <b class="text-danger">border-block-width</b>
        </li>
        <li class="list-group-item">
             <b class="text-danger">border-block-style</b>
        </li>
        <li class="list-group-item"><b class="text-danger">border-block-color</b></li>
    </ul>
    <CopyBlock
    language={"css"}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

     
    <div className="alert alert-secondary" role="alert">
    <h4><strong>Border Collapse</strong></h4>
<p>The <b class="text-danger">border-collapse</b> property sets whether table borders should collapse into a single border or be separated as in standard HTML.</p>
 <p>We shall look at tables in a separate lesson.</p>
 <CopyBlock
    language={"css"}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>



    <div className="alert alert-secondary" role="alert">
 <h4><strong>Border Radius</strong></h4>
<p>The <b class="text-danger">border-radius</b> property defines the radius of the element's corners.</p>
 <p>This property allows you to add rounded corners to elements and can have from one to four values.</p>
 <p><b class="text-danger">Four values - border-radius: 15px 50px 30px 5px;</b> (first value applies to top-left corner, second value applies to top-right corner, third value applies to bottom-right corner, and fourth value applies to bottom-left corner)</p>
<p><b class="text-danger">Three values - border-radius: 15px 50px 30px;</b> (first value applies to top-left corner, second value applies to top-right and bottom-left corners, and third value applies to bottom-right corner):</p>
 <p><b class="text-danger">Two values - border-radius: 15px 50px;</b> (first value applies to top-left and bottom-right corners, and the second value applies to top-right and bottom-left corners):</p>
 <p><b class="text-danger">One value - border-radius: 15px;</b> (the value applies to all four corners, which are rounded equally:)</p>
 <CopyBlock
    language={"css"}
    text={code5}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    /> <p><b class="text-primary">Short-hand property</b></p>

<CopyBlock
    language={"css"}
    text={code6}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
                  


    
                          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson37;
